import type { CostOptimizationPoint } from '../subscriptionBillingStat.types';

export class CostOptimizationPointModel {
  private readonly _dto: CostOptimizationPoint;

  constructor(dto: CostOptimizationPoint) {
    this._dto = dto;
  }

  get originDTO(): CostOptimizationPoint {
    return this._dto;
  }

  get type() {
    return this._dto.type;
  }

  get isUserOptimzationPoint() {
    return (
      this._dto.type === 'DEACTIVATED_USER' ||
      this._dto.type === 'FORMER_TENANT_MEMBER' ||
      this._dto.type === 'MONTHLY_INACTIVE_USER' ||
      this._dto.type === 'NON_TENANT_MEMBER'
    );
  }

  get isPlanOptimizationPoint() {
    return false;
  }

  get description() {
    switch (this.type) {
      case 'DEACTIVATED_USER':
      case 'MONTHLY_INACTIVE_USER':
      case 'FORMER_TENANT_MEMBER':
      case 'NON_TENANT_MEMBER':
        return `Optimizable_Subscription.${this.type}`;
      case 'CUSTOM':
      default:
        return this._dto.description;
    }
  }

  get usage() {
    return this._dto.usage;
  }

  get cost() {
    // return this._dto.cost;
    return this._dto.usage;
  }
}
